import { Controller } from "@hotwired/stimulus"

/**
 * Admin Dialog Controller - Handles modal dialogs with Turbo Frame support
 *
 * Usage:
 * Trigger dialog open:
 *   <button data-action="click->admin-dialog#open" data-admin-dialog-target-value="dialog-id">
 *     Open Dialog
 *   </button>
 *
 * Dialog markup:
 *   <%= render AdminPanel::UI::DialogComponent.new(id: "dialog-id", title: "Title") do |d| %>
 *     ...
 *   <% end %>
 */
export default class extends Controller {
  static values = {
    id: String,
    target: String
  }

  // Open the dialog
  open(event) {
    const targetId = event.params?.target || this.targetValue
    if (targetId) {
      const dialog = document.querySelector(`[data-admin-dialog-id-value="${targetId}"]`)
      if (dialog) {
        dialog.classList.remove("hidden")
        document.body.style.overflow = "hidden" // Prevent body scroll
      }
    }
  }

  // Close the dialog
  close(event) {
    event?.preventDefault()
    this.element.classList.add("hidden")
    document.body.style.overflow = "" // Restore body scroll
  }

  // Close on Escape key
  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
